export default {
	login: {
		token: null,
		expires_in: null,
		loginTime: null
	},
	loading: false,
	unauthorized: false,
	showErrBlock: false,
	sessionExpired: false,
	timeLeft: 90,
	eScript: false,
	patientInfo: {},
	fcmToken: null,
	deviceId: null,
	groupRequestDetails: {},
	groupRequestId: null,
	showAlert: {},
	fromGroupRequests: false,
	scriptRequestDetails: {},
	notificationStatus: 0,
	name: "",
	receivedMessage:{},
	received:{},
	frompath:'',
	pharmacyData:{},
	chatIdPayload:{
        formReferenceId:"",
        formManagementId:"",
    }
}